<template>
    <div id="container">
        <div v-if="isUserVoted=='0'">
            <div class="box">
                <div class="h5"> Hvordan vil du bedømte din levering?</div>
            </div>
            <div class="box">
                <star-rating :show-rating="false" :read-only="showText===false"
                             v-model="ratingData.rating"></star-rating>
            </div>
            <div class="box">
                <form @submit.prevent="rate">
                    <div class="form-group">
                        <div class="bg-white border rounded-lg div-focus border-2" v-if="showText">
                                <textarea
                                    autocomplete="none"
                                    v-model="ratingData.comment"
                                    rows="5"
                                    cols="30"
                                    class="form-control border-0  shadow-none form-input"
                                    placeholder="Tilføj valgfri kommentar"
                                >
                                </textarea>
                        </div>
                        <div v-else><i> tak for din bedømmelse </i></div>
                    </div>
                    <div class="form-group" v-if="showText">
                        <button class="btn btn-success">Bedøm</button>
                    </div>
                </form>
            </div>
        </div>
        <div class="box" v-else>
            <i> tak for din bedømmelse </i>
        </div>
    </div>
</template>

<script>
import StarRating from 'vue-star-rating'

export default {
    name: "Rate",
    components: {
        StarRating
    },
    props: {
        booking: {type: String, required: true},
        isUserVoted: {type: String, required: true},
    },
    data() {
        return {
            ratingData: {
                rating: 3,
                comment: '',
            },
            showText: true,
            validationErrors: true
        }
    },
    methods: {
        rate() {
            axios.post(`/mobile/store-rate/${this.booking}`, this.ratingData).then((response) => {
                this.showText = false
            }).catch(e => {
                this.validationErrors = e.response.data.errors
            })
        },
    },
}
</script>

<style scoped>
#container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.box {
    margin: 5px;
    text-align: center; /* will center text in <p>, which is not a flex item */
}

.vue-star-rating {
    display: block !important;
}
</style>
